import { ENotAuthNavigation } from '@hts/shared/enums';
import { useIsMobile } from '@hts/shared/libs';
import { HtsLink, HtsTypography, HtslIcon } from '@hts/shared/ui';
import { memo } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Link } from 'react-router-dom';
import styles from '../styles/CardGalleryItem.module.scss';

interface ICardGalleryProps {
  src: string;
  title: string;
  name: string;
  price: number;
  cardId: number;
}

export const CardGalleryItem: React.FC<ICardGalleryProps> = memo(
  ({ cardId, name, price, src, title }) => {
    const isMobile = useIsMobile();

    const linkTo = `${ENotAuthNavigation.CARD}/${cardId}`;

    return (
      <div className={styles.centerContainer}>
        <div className={styles.container}>
          <Link to={linkTo} className={styles.imageLink}>
            <LazyLoadImage
              src={src}
              alt={title}
              effect="blur"
              wrapperClassName={styles.imageWrapper}
            />
          </Link>

          <div className={styles.contentContainer}>
            <div>
              <HtsLink
                label={title}
                redirectTo={linkTo}
                typographyProps={{ variant: isMobile ? 'subtitle' : 'body2', fontWeight: '500' }}
              />

              <HtsTypography variant="caption" fontWeight="500" color="gray11">
                {name}
              </HtsTypography>
            </div>

            <div>
              <HtsTypography variant={isMobile ? 'subtitle' : 'h2'} element="p" fontWeight="500">
                ${price}
              </HtsTypography>

              <Link to={linkTo}>
                <HtslIcon icon="edit-circle" color="primaryDark" className={styles.editIcon} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
);
